<template>
    <div>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='消息Id'>
                                <el-input v-model="queryParams.id" placeholder="请输入消息Id" size="mini" clearable />
                            </el-form-item>
                            <el-form-item label='发送者Id'>
                                <el-input v-model="queryParams.senderId" placeholder="请输入发件人Id" size="mini" clearable />
                            </el-form-item>
                            <el-form-item label='收件人Id'>
                                <el-input v-model="queryParams.recipientId" placeholder="请输入收件人Id" size="mini" clearable />
                            </el-form-item>
                            <el-form-item label='消息内容'>
                                <el-input v-model="queryParams.messageRegex" placeholder="搜索的聊天内容 支持正则" size="mini" clearable />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='reset'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='tableDataList'
                      @sort-change='handleSortChange'>
                <el-table-column width='250' label='Id' align='center' prop='id' />
                <el-table-column label='类型' align='center'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' :type='scope.row.messageCategory === 0 ? "warning": "success"'>
                            {{ scope.row.messageCategory === 0 ? '频道' : '私聊' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label='发送者' width='250' align='center' prop='senderId' />
                <el-table-column label='收件人' width='250' align='center' prop='recipientId' />
                <el-table-column width='300' label='内容' align='center'>
                    <template slot-scope='scope'>
                        <div class='im-table-content'>
                            {{scope.row.content}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width='200' sortable='custom' label='创建时间' align='center' prop='createTime' />
                
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        
                        <el-button
                            size='mini'
                            type='text'
                            @click='handleDetails(scope.row)'
                        >详情
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :visible.sync='open' :title='title' width='40%' append-to-body @close='cancel'>
                <el-form label-width='150'>
                    <el-form-item label="消息内容">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 10}"
                            placeholder="消息内容"
                            v-model="currentTableData.content">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="消息参数">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 10, maxRows: 20}"
                            placeholder="如果需要修改消息参数, 请询问客户端和服务端开发人员. 并且部分参数存在时效性, 可能修改之后, 也并不会改变消息的某些行为"
                            v-model="msgParam">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <div>
                        <el-button type='primary' @click='submitForm'>{{ updateStatus ? '修 改' : '添 加' }}</el-button>
                        <el-button @click='cancel'>取 消</el-button>
                    </div>
                </div>
            </el-dialog>
            
            <el-dialog :visible.sync='openMsgDetails' title='消息详情' width='40%'>
                <vue-json-pretty :data='currentTableData'/>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { defineComponent } from 'vue';
import bus from '@/components/common/bus';
import { message } from '@/utils/message';
import { pageUtil } from '@/utils/pageUtil';
import { imMessageApi } from '@api/Im/ImMessageApi';
import { deepCopy } from '@/utils/object';

export default defineComponent({
    name: 'ImSummary',
    components: { VueJsonPretty },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                projectName: undefined,
                id: undefined,
                senderId: undefined,
                recipientId: undefined,
                messageRegex: undefined
            },
            projectInfo: {},
            tableDataList: [],
            currentTableData: {},
            openMsgDetails: false,
            msgParam: undefined
        };
    },
    created() {
        this.setInitValue();
        if (this.queryParams.projectName) {
            bus.$emit('queriedImProjectName', this.queryParams.projectName);
        }
        
        bus.$on('selectedImProjectName', this.handleSelectedImProjectNameEvent);
    },
    beforeDestroy() {
        bus.$off('selectedImProjectName', this.handleSelectedImProjectNameEvent);
    },
    computed: {

    },
    methods: {
        reset() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                id: undefined,
                senderId: undefined,
                recipientId: undefined,
                messageRegex: undefined,
                
                projectName: this.queryParams.projectName
            };
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                // 修改操作
                try {
                    this.currentTableData.param = JSON.parse(this.msgParam);
                } catch (e) {
                    message.error("解析消息参数出错")
                    return
                }
                imMessageApi.update(this.currentTableData, this.queryParams.projectName).then(result => {
                    if (result.code === 200) {
                        message.success(result.message)
                        this.open = false
                        this.getList()
                        this.msgParam = undefined
                    }
                })
            } else {
                // 全部都是新增
                
            }
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改消息数据';
            this.updateStatus = true;
            this.currentTableData = deepCopy(row);
            this.msgParam = JSON.stringify(this.currentTableData.param, null, 2)
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let projectName = this.queryParams.projectName
            this.$modal.confirm('是否删除"' + row.content + '"消息？').then(function() {
                return imMessageApi.deleteData(row, projectName)
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        getList() {
            this.loading = true;
            if (!this.queryParams.projectName || this.queryParams.projectName.indexOf('undefined') === 0) {
                message.error('请选择项目!');
                return;
            }
            
            imMessageApi.query(this.queryParams, this.queryParams.projectName).then(result => {
                if (result.code === 200) {
                    if (result.data) {
                        this.tableDataList = result.data.result;
                    }
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            })
        },
        handleSelectedImProjectNameEvent(t) {
            this.queryParams.projectName = t;
            this.$router.push(`/im/messages/${t}`);
            this.setInitValue();
        },
        setInitValue() {
            this.queryParams.projectName = undefined;
            if (this.$route.params.projectName && this.$route.params.projectName.indexOf('undefined') === -1) {
                this.queryParams.projectName = this.$route.params.projectName;
            }
            if (!this.queryParams.projectName) {
                message.error('请选择项目!');
                return;
            }
            this.getList();
        },
        handleDetails(data) {
            this.currentTableData = deepCopy(data)
            this.openMsgDetails = true
        }
    }
});
</script>

<style scoped lang='css'>
.new-user-client-tag {
    max-height: 20rem;
    overflow-y: scroll;
}

.new-user-client-tag li {
    margin-top: .5rem;
}
.im-table-content {
    display: -webkit-box;             /* 使用弹性盒模型 */
    -webkit-box-orient: vertical;    /* 垂直方向排列子元素 */
    -webkit-line-clamp: 4;           /* 限制行数为 4 */
    overflow: hidden;                 /* 隐藏超出的内容 */
    text-overflow: ellipsis;          /* 使用省略号表示超出部分 */
    line-height: 1.5;                 /* 设置行高（可自定义） */
    max-height: calc(1.5em * 4);
}
</style>
